import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  const languages = [
    { code: 'pt-BR', flag: '🇧🇷', name: 'PT' },
    { code: 'en', flag: '🇺🇸', name: 'EN' },
    { code: 'de', flag: '🇩🇪', name: 'DE' }
  ];

  const currentLanguage = languages.find(lang => lang.code === currentLang);

  return (
    <Select value={currentLang} onValueChange={onLanguageChange}>
      <SelectTrigger className="w-[100px] h-9 bg-bg-secondary border-border-primary text-text-primary hover:bg-bg-tertiary transition-colors">
        <div className="flex items-center gap-2">
          <Globe className="w-4 h-4 text-cyan-400" />
          <span className="text-sm">{currentLanguage?.flag} {currentLanguage?.name}</span>
        </div>
      </SelectTrigger>
      <SelectContent className="bg-zinc-800 border-2 border-accent-primary/40 shadow-2xl">
        {languages.map((lang) => (
          <SelectItem 
            key={lang.code} 
            value={lang.code}
            className="text-white hover:bg-accent-primary hover:text-black cursor-pointer transition-colors focus:bg-accent-primary focus:text-black data-[highlighted]:bg-accent-primary data-[highlighted]:text-black"
          >
            <div className="flex items-center gap-2">
              <span className="text-base">{lang.flag}</span>
              <span className="font-medium">{lang.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;